import { useEffect, useState } from "react";
import { adresPro2, findLokal, sortujLokale } from "../../../../functions/ulice";
import { handleBlur, handleFocus } from "../../../../functions/utilities";
import { dataFormat } from "../../../../functions/dataFormat";
import axios from "axios";
import { fetchPrzelewy } from "../../../../Redux/Actions";
import { useDispatch } from "react-redux";

const ImportTransakcjiInd = props => {

    const { handleOpenInd, wybranaWspolnota, banki, mieszkancy, udzialyKontaAkt, grupy, lokale, ulice, przelewy } = props;

    const [zestaw, setZestaw] = useState([]);
    const [nazwaBanku, setNazwaBanku] = useState("");
    const [daneMieszkaniec, setDaneMieszkaniec] = useState([]);
    const [data, setData] = useState("");
    const [kwota, setKwota] = useState(0);
    const [tytul, setTytul] = useState("");
    
    const dispatch = useDispatch();

    useEffect( () => setNazwaBanku(banki?.find(  b => b.id === wybranaWspolnota?.id_bank )?.nazwa), [wybranaWspolnota, banki])


    useEffect( () => {
        const temp = udzialyKontaAkt?.map( (udzial, i) => {
            const mieszkaniec = mieszkancy?.find( m => m?.id_user == udzial?.id_user);
            const lokal = findLokal(udzial, grupy, lokale);
            const adres = adresPro2(udzial, lokale, ulice, grupy);
            return ({
                id: i,
                udzial,
                mieszkaniec,
                adres,
                ulicaId: lokal?.ulica,
                lokalNr: lokal?.numer
            })
        })
        setZestaw( sortujLokale(temp) )
    },[udzialyKontaAkt, mieszkancy, grupy, lokale, ulice])

    const lista = zestaw?.map( (element, i)=>{

        return (
            <option
                key={i}
                value={element.id}
            >
                {`${element?.mieszkaniec?.imie_nazwisko}, ${element?.adres} (gr. ${element.udzial.grupa_numer})`}
            </option>
        )
    })

    const handleSelect = (e) => setDaneMieszkaniec( zestaw?.find( z => z?.id == e.target.value) )
    const handleData = e => setData(e.target.value);
    const handleTytul = e => setTytul(e.target.value);
    const handleKwota = e => setKwota(e.target.value);
    console.log(daneMieszkaniec) 
    const handleSave = async () => {
        const id_transkacji = 'przelew_z_palca_form';
        const item = {
            id_transkacji,
            data_operacji: data,
            data_wczytania: new Date(),
            kwota: kwota,
            id_user: daneMieszkaniec?.mieszkaniec?.id_user,
            grupa_numer: daneMieszkaniec?.udzial?.grupa_numer,
            id_wspolnoty: wybranaWspolnota?.id,
            nadawca_nazwa: '',
            nadawca_konto: '',
            nazwa_transakcji: tytul,
            nazwa_pliku: 'przelew z palca',
            operacja: 'przelew przychodzący',
            odbiorca_nazwa: 'Wspólnota (konto grupy)',
            odbiorca_konto: daneMieszkaniec?.udzial?.konto_bankowe        
        }

        try {
            const response = await axios.post('/api/przelewy/dodaj', item);
            dispatch(fetchPrzelewy(wybranaWspolnota.id));
            handleOpenInd();
            // console.log(`Response for item ${index}:`, response.data);
              
        } catch (error) {
            // console.error(`Error for item ${index}:`, error);
        }
    }

    return (
        <div 
            className="importIndTlo"
            // onClick={handleOpenInd}
        >
            <div className="modal">
                <h5>Import pojedynczych przelewów</h5>
                <div className="w">
                    <label id="udzialy">
                        Wybierz mieszkańca i jego grupę czynszową:
                    </label>
                    <select
                        id="udzialy"
                        onChange={handleSelect}
                    >   
                        <option value={0}>Wybierz</option>
                        {lista}
                    </select>
                </div>
                <div className="w">
                    <label id="data">
                        Data transakcji:
                    </label>
                    <input 
                        id="data"
                        onChange={handleData}
                        type="date"
                        value={data}
                    />
                </div>
                <div className="w">
                    <label id="tytul">
                        Tytuł
                    </label>
                    <input 
                        id="tytul"
                        onChange={handleTytul}
                        value={tytul}
                        type="text"
                    />
                </div>
                <div className="w">
                    <label id="kwota">
                        Kwota:
                    </label>
                    <input
                        id="kwota"
                        type="number"
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        value={kwota}
                        onChange={handleKwota}
                    />
                </div>
                <div className="buttons">
                    <button onClick={handleSave}>
                        Zapisz
                    </button>
                    <button onClick={handleOpenInd}>
                        Anuluj
                    </button>
                </div>
            </div>
        </div>

    )
}

export default ImportTransakcjiInd;